// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aviso-sem-agendamento[data-v-fc9835d8]{text-align:center;font-size:1.6em;font-family:Lato}.cancelamento-container[data-v-fc9835d8]{font-size:1rem}.cancelamento-container table[data-v-fc9835d8]{font-size:1rem;text-align:left;margin-top:1rem}.cancelamento-container th[data-v-fc9835d8]{font-weight:400}.cancelamento-container td[data-v-fc9835d8]{font-weight:700;border:none}", ""]);
// Exports
module.exports = exports;
